import { georgeStats, trackEvent2 } from '@shared/statistics';
import { useNotifications } from '@shared/snackbar';
import { t } from '@luna/i18n';

const SHOW_ON_OVERVIEW_TRACKING = 'overview_show';
const HIDE_ON_OVERVIEW_TRACKING = 'overview_hide';

const SHOW_ON_OVERVIEW = false;
const HIDE_ON_OVERVIEW = true;

export type HookParams = {
    onChange: (hidden: boolean) => Promise<void>;
    productType?: string;
};

type OverviewAppearanceChangeHook = (params: HookParams) => {
    showAccountOnOverview: () => void;
    hideAccountOnOverview: () => void;
};

export const useOverviewAppearanceChange: OverviewAppearanceChangeHook = ({
    onChange,
    productType = '',
}) => {
    const { displaySuccess } = useNotifications('product-settings-details-dashboard-appearance');
    const updateOverviewAppearance = async (hidden: boolean): Promise<void> => {
        await onChange(hidden);
        georgeStats.trackEvent(
            'details',
            hidden ? HIDE_ON_OVERVIEW_TRACKING : SHOW_ON_OVERVIEW_TRACKING,
        );
        trackEvent2('productCustomisationChanges', 'productCustomised', {
            customisationChanges: ['overviewVisibility'],
            overviewState: hidden ? 'hidden' : 'visible',
            productType,
        });

        const changeActionSuccessMessage = hidden
            ? 'products.settings.details.hiddenOnOverview'
            : 'products.settings.details.shownOnOverview';

        displaySuccess(t(changeActionSuccessMessage));
    };
    return {
        showAccountOnOverview: () => updateOverviewAppearance(SHOW_ON_OVERVIEW),
        hideAccountOnOverview: () => updateOverviewAppearance(HIDE_ON_OVERVIEW),
    };
};
